<div class="container-fluid">
    
    <app-pagetitle title="Order Detail"></app-pagetitle>

    <div class="page-content-wrapper">

        <app-loader [loading]="generatingInvoice"></app-loader>

        <div [class.loading-content]="generatingInvoice">

            <div class="card">

                <div class="card-header d-flex align-items-center gap-2">
                    <button type="button" class="btn btn-light btn-sm rounded-circle shadow-sm" (click)="back()"
                        ngbTooltip="Back">
                        <i class="mdi mdi-arrow-left"></i>
                    </button>

                    <h5 class="mb-0">Order Detail</h5>
                </div>

                <div class="card-body">

                    <div class="row">

                        <div class="col-md-6 mb-3">
                            <div class="fw-semibold">BSR Id</div>
                            <div>{{ orderDetail?.bsrId || '-' }}</div>
                        </div>

                        <div class="col-md-6 mb-3">
                            <div class="fw-semibold">Status</div>
                            <span class="badge rounded-pill px-2 py-1" [ngClass]="getStatusClass(orderDetail?.status)">
                                {{ orderDetail?.status || '-' }}
                            </span>
                        </div>

                        <div class="col-md-6 mb-3">
                            <div class="fw-semibold">Client Name</div>
                            <div>{{ orderDetail?.clientName || '-' }}</div>
                        </div>

                        <div class="col-md-6 mb-3">
                            <div class="fw-semibold">Client Email</div>
                            <div>{{ orderDetail?.clientEmail || '-' }}</div>
                        </div>

                        <div class="col-md-6 mb-3">
                            <div class="fw-semibold">Maker Name</div>
                            <div>{{ orderDetail?.userName || '-' }}</div>
                        </div>


                        <div class="col-md-6 mb-3">
                            <div class="fw-semibold">Total Value</div>
                            <div>₹{{ orderDetail?.totalValue || 0 }}</div>
                        </div>

                        <ng-container *ngIf="orderDetail?.invoice as invoice">

                            <div class="col-md-6 mb-3">
                                <div class="fw-semibold">Service Charge</div>
                                <div>₹{{ invoice.serviceCharge ?? 0 }}</div>
                            </div>

                            <div class="col-md-6 mb-3">
                                <div class="fw-semibold">Grand Total</div>
                                <div>₹{{ invoice.grandTotal ?? 0 }}</div>
                            </div>

                        </ng-container>

                        <div class="col-md-12 mb-3">
                            <div class="fw-semibold mb-1">Items</div>

                            <div class="table-responsive">
                                <table class="table table-sm table-bordered mb-0">
                                    <thead class="table-light">
                                        <tr>
                                            <th>State</th>
                                            <th class="text-end">Denomination</th>
                                            <th class="text-end">Quantity</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let item of orderDetail?.items">
                                            <td>{{ item.stateName }}</td>
                                            <td class="text-end">₹{{ item.denomination }}</td>
                                            <td class="text-end">{{ item.quantity }}</td>
                                        </tr>

                                        <tr *ngIf="!orderDetail?.items?.length">
                                            <td colspan="3" class="text-center text-muted">No items</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-6 mb-3" *ngIf="orderDetail?.excelUrl">
                            <div class="fw-semibold">Uploaded File</div>
                            <a [href]="orderDetail?.excelUrl" target="_blank" rel="noopener">
                                {{ orderDetail?.originalFileName || 'Download' }}
                            </a>
                        </div>

                        <div class="col-md-6 mb-3" *ngIf="orderDetail?.paymentProofUrl">
                            <div class="fw-semibold">Payment Proof</div>
                            <a [href]="orderDetail?.paymentProofUrl" target="_blank" rel="noopener">
                                View Payment Proof
                            </a>
                        </div>

                        <div class="col-md-6 mb-3">
                            <div class="fw-semibold">Created At</div>
                            <div>{{ orderDetail?.createdAt | date:'medium' }}</div>
                        </div>

                        <div class="col-md-6 mb-3">
                            <div class="fw-semibold">Updated At</div>
                            <div>{{ orderDetail?.updatedAt | date:'medium' }}</div>
                        </div>

                    </div>

                </div>

                <div class="card-footer text-end" *ngIf="orderDetail?.status === 'ORDER_CREATED'">
                    <button type="button" class="btn btn-primary d-inline-flex align-items-center"
                        (click)="onGenerateInvoice()" [disabled]="generatingInvoice">
                        <i class="mdi mdi-receipt me-1"></i>
                        {{ generatingInvoice ? 'Generating...' : 'Generate Invoice' }}
                    </button>
                </div>

                <div class="card-footer" *ngIf="orderDetail?.status === 'PAYMENT_SUBMITTED'">

                    <div class="mb-3 d-flex gap-4">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="paymentAction" id="paymentVerify"
                                value="VERIFY" [(ngModel)]="paymentAction">
                            <label class="form-check-label" for="paymentVerify">Verify Payment</label>
                        </div>

                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="paymentAction" id="paymentReject"
                                value="REJECT" [(ngModel)]="paymentAction">
                            <label class="form-check-label" for="paymentReject">Reject Payment</label>
                        </div>
                    </div>

                    <div *ngIf="paymentAction === 'VERIFY'">
                        <div class="mb-2">
                            <label class="form-label fw-semibold">Verification Reason</label>
                            <textarea class="form-control" rows="2" [(ngModel)]="verifyReason"
                                placeholder="Enter reason for verifying the payment"></textarea>
                        </div>

                        <div class="text-end">
                            <button type="button" class="btn btn-primary d-inline-flex align-items-center"
                                (click)="orderProcess()" [disabled]="generatingInvoice">
                                <i class="mdi mdi-receipt me-1"></i>
                                {{ generatingInvoice ? 'Verifying...' : 'Verify Payment' }}
                            </button>
                        </div>
                    </div>

                    <div *ngIf="paymentAction === 'REJECT'">
                        <div class="mb-2">
                            <label class="form-label fw-semibold">Rejection Reason</label>
                            <textarea class="form-control" rows="2" [(ngModel)]="rejectReason"
                                placeholder="Enter reason for rejecting the payment"></textarea>
                        </div>

                        <div class="text-end">
                            <button type="button" class="btn btn-danger d-inline-flex align-items-center"
                                (click)="onRejectPayment()" [disabled]="rejectingPayment">
                                <i class="mdi mdi-close-circle me-1"></i>
                                {{ rejectingPayment ? 'Rejecting...' : 'Reject Payment' }}
                            </button>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>